import { Fancybox } from "@fancyapps/ui";

// captions

document.querySelectorAll('.wp-block-gallery .wp-block-image img').forEach(img => {
    let figcaption = img.parentElement.querySelector('figcaption');
    if (figcaption) {
        img.setAttribute('data-caption', figcaption.innerHTML);
    }
});

// init

Fancybox.bind('.wp-block-gallery .wp-block-image img', {
    groupAll: true
});

document.querySelectorAll('.fancybox.download a').forEach(a => {
    let href = a.getAttribute('href');
    if (href) {
        a.setAttribute('data-caption', '<i class="fa-regular fa-download" role="presentation"></i>&nbsp; <a href=\'' + href + '\' target=\'_blank\' role="button"> Download</a>');
    }
});

Fancybox.bind('.fancybox a');